<template>
  <div class="repeat">
    <content-top
      :title="repeatFieldTit"
      :untext="unTTxt"
      :fields="fields"
      @edit="toEdit"
    />
    <a-modal
      :title="repeatTit"
      :visible="visibleEditModal"
      :ok-text="okTTxt"
      :cancel-text="cancelTxt"
      :mask-closable="false"
      @ok="handleConfirmSubmit"
      @cancel="handleCancel"
    >
      <div class="modal_content">
        <modal-search
          :data-source="dataSource"
          @select="onSelect"
          @search="onSearch"
        />
        <div
          ref="check_main"
          class="modal_main"
        >
          <a-form :form="form">
            <a-form-item>
              <a-checkbox-group
                v-decorator="['data', {initialValue: setedFields}]"
                class="fields_group scroll_bar_beautify_ff"
                :options="allRepeatData"
              />
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script type="text/ecmascript-6">
import ContentTop from './ContentTop'
import ModalSearch from '@/components/pc/config/sensitive/ModalSearch'
import { mapState, mapActions } from 'vuex'

const FIXED_FIELD = 'contact_mobile'

export default {
  components: { ContentTop, ModalSearch },
  props: {
    fields: {
      type: Array,
      default: () => ({})
    }
  },
  data () {
    return {
      visibleEditModal: false,
      form: this.$form.createForm(this),
      dataSource: []
    }
  },
  computed: {
    ...mapState('config/repeat', ['allRepeatFields']),
    setedFields () {
      return this.allRepeatFields.filter(item => item.fieldrepeat === 1).map(item => item.fieldname)
    },
    allRepeatData () {
      return this.allRepeatFields.map(item => {
        let disabled = item.fieldkey === FIXED_FIELD
        return { 'value': item.fieldname, 'label': item.fieldname, 'id': item.id, disabled }
      })
    },
    repeatTit () {
      return this.$t('message["38"]')
    },
    repeatFieldTit () {
      return this.$t('message["97"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    unTTxt () {
      return this.$t('message["1545"]')
    }
  },
  watch: {
    visibleEditModal (newValue) {
      newValue && this.fetchAllRepeatData()
    }
  },
  methods: {
    ...mapActions('config/repeat', ['fetchAllRepeatData', 'searchFields', 'setRepeatFields']),
    toEdit () {
      this.visibleEditModal = true
    },
    handleConfirmSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = []
          let originalValues = [].concat(...this.allRepeatFields)
          for (let i = 0; i < values.data.length; i++) {
            let item = values.data[i]
            for (let k = 0; k < originalValues.length; k++) {
              if (item === originalValues[k].fieldname) {
                data.push(originalValues[k].id)
                originalValues.splice(k, 1)
                break
              }
            }
          }
          this.setFields(data)
        }
      })
    },
    handleCancel () {
      this.visibleEditModal = false
    },
    async setFields (data) {
      const chain = await this.setRepeatFields()
      chain.params({ data })
        .onSuccess(res => {
          this.handleCancel()
          this.$emit('submit')
        })
        .fetch()
    },
    onSelect (e) {
      this.$nextTick(() => {
        let key = 0
        let container = this.$refs.check_main
        for (let i = 0; i < this.allRepeatFields.length; i++) {
          if (this.allRepeatFields[i].fieldname === e) {
            key = i
            break
          }
        }
        let toTopDistence = container.children[0][key].scrollHeight * key + (key * 5)
        document.querySelector('.fields_group').scrollTop = toTopDistence
      })
    },
    async onSearch (value) {
      const chain = await this.searchFields()
      chain.params({ 'key': value, edit: 1 })
        .onSuccess(res => {
          this.dataSource = res.map(item => item.fieldname).length > 0 ? res.map(item => item.fieldname) : [this.$t('message["1553"]')]
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.modal_content {
  width: 400px;
  margin: 20px auto 0 auto;
}
.modal_main {
  margin: 20px 0;
}
</style>

<style lang="scss">
.repeat {
  .ant-modal-content {
    max-height: 550px !important;
  }
}
.fields_group {
  height: 270px;
  overflow-y: auto;
  .ant-checkbox-group-item {
    width: 100% !important;
    height: 32px !important;
    margin: 0 !important;
    line-height: 32px;
  }
  .ant-checkbox-group-item:hover {
    background: #f4f7f9 !important;
  }
}
</style>
